import { IMPORT_TAX_SERVICE_FAIL, IMPORT_TAX_SERVICE_START, IMPORT_TAX_SERVICE_SUCCESS } from "../Actions/types"

const INITIAL_STATE = {
  error: "",
  loading: false,

  data: [],
  totalcount: 0,
  rowsPerPage: 0,
  page: 0,
  order: "asc",
  orderBy: "name",
  search_text: "",
  columnData: [
    { id: "name", numeric: false, visible: true, label: "Name" },
    { id: "code", numeric: false, visible: false, label: "Code" },
  ],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IMPORT_TAX_SERVICE_START:
      return { ...state, loading: true, error: "" }
    case IMPORT_TAX_SERVICE_SUCCESS:
      return {
        ...state,
        ...INITIAL_STATE,
        data: action.payload.data.result,
        totalcount: action.payload.data.total_count,
        rowsPerPage: action.rowsPerPage,
        page: action.page,
        order: action.order,
        orderBy: action.orderBy,
        search_text: action.search_text,
        islogin: true,
      }
    case IMPORT_TAX_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
        data: [],
        loading: false,
        totalcount: 0,
        rowsPerPage: action.rowsPerPage,
        page: action.page,
        order: action.order,
        orderBy: action.orderBy,
        search_text: action.search_text,
      }

    default:
      return state
  }
}
